/**
 *组件UI状态类型
 * @type {{readPretty: string, editable: string, readOnly: string, disabled: string}}
 */
export const FormPatternTypes = {
    editable: "editable", //可编辑
    readOnly: "readOnly", //只读
    disabled: "disabled", //禁用
    readPretty: "readPretty", //阅读
};
